var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C3C43",
  strokeLinecap: "round",
  strokeOpacity: 0.6,
  strokeWidth: 1.25,
  d: "M20.49 11.143a1.55 1.55 0 0 1 0 1.714C19.404 14.515 16.574 18 12 18s-7.403-3.485-8.491-5.143a1.55 1.55 0 0 1 0-1.714C4.597 9.485 7.427 6 11.999 6c4.574 0 7.404 3.485 8.492 5.143Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C3C43",
  strokeLinecap: "round",
  strokeOpacity: 0.6,
  strokeWidth: 1.25,
  d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
})));
export default SvgEye;